/* eslint-disable prettier/prettier */
/* eslint-disable prefer-const */
import { huyi } from "./clog";

const getDomainByEnv = () => {
  if (
    window.location.hostname.includes("testing") ||
    window.location.hostname.includes("internal-medpro.ddns.net") ||
    window.location.hostname.includes("localhost")
  ) {
    return "https://bo-api-testing.medpro.com.vn";
  } else {
    return "https://bo-api.medpro.com.vn:5000";
  }
};

export const findPartner = () => {
  var xhr = new XMLHttpRequest();
  xhr.open(
    "GET",
    getDomainByEnv() +
      "/partner-domain/get-by-domain?domain=" +
      window.location.hostname,
    false
  );
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
  xhr.send();

  const partner = xhr.status === 200 ? JSON.parse(xhr.response) : null;
  console.log("partner :>> ", partner);
  return partner;
};

const localhost = {
  name: "hotfix",
  domain: ["localhost", "192.168.0.145", "huyi.ddns.net"],
  partnerId: "cskh"
};

const findPartnerByDomain = () => {
  // if (findPartner()) {
  //   return findPartner().partnerId;
  // } else {
  return localhost.partnerId;
  // }
};
//
export default findPartnerByDomain();

huyi({
  name: "Dừng lại !, Đây là tính năng của nhà phát triển Medpro !",
  child: "",
  type: "error"
});
